import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiError } from '@features/advanced-errors/types/ApiError';



interface AdvancedErrorsState {
	apiErrors: ApiError[]
};


const initialState: AdvancedErrorsState = {
	apiErrors: []
};



export const advancedErrorsSlice = createSlice({
	name: 'advancedErrors',
	initialState,
	reducers: {
		addApiError: (state, action: PayloadAction<ApiError>) => {
			state.apiErrors.push(action.payload);
		},
		clearApiErrors: (state) => {
			state.apiErrors = initialState.apiErrors;
		}
	},
});



export const {
	addApiError,
	clearApiErrors } = advancedErrorsSlice.actions;